// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"AttributionReturnRate-primaryButton-135LD0","description":"AttributionReturnRate-description-1rJby4","inputContainer":"AttributionReturnRate-inputContainer-31HnHA"};